/**
 * Copyright ©2024 Drivepoint
 */

import {Config} from "@bainbridge-growth/node-frontend";
import type {DPError, ErrorAction} from "./DPError";
import {ERROR_DEFINITIONS} from "./DPErrorDefinition";

export type DPErrorHandlerResult = {
  message: string;
  action?: ErrorAction;
};

export default class ErrorHandling {

  static handle(error: DPError): DPErrorHandlerResult {
    const message = ERROR_DEFINITIONS[error.code]?.(error.context);
    if (message) { return {message, action: error.action}; }

    logger.error("unhandled error", error);
    return {message: error.message};
  }

  static contactSupport(event: any): void {
    event?.preventDefault();
    event?.stopPropagation();
    window.open(Config.get("urls.customer_support"), "_blank");
  }

}
